<script>
import Vue from 'vue'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

 import {
  required,
  minLength,
  maxLength,
  email
  

} from 'vuelidate/lib/validators' 


/**
 * Agregar Usuario Component
 */
export default {
  components: { Layout, PageHeader,Multiselect},
  page: {
    title: 'Usuarios',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {     
      title: 'Usuarios',
      form: {
        nombreUsuario: '',
        nombre:'',        
        correo: '',
        contrasena: ''        ,
        caja:{
          serie:'',
          descripcion:'',
          cajaId:null
        },
        rol:{
          rolId:null,
          descripcion:''
        }        
      },
      isLoadingComboCajas: false,
      listadoCajas: [],
      requestComboCajas: {
        perPage: 100,
        cuerrentPage: 0,
        filter: '',
      },      
      isLoadingComboRol: false,
      listadoRol: [],
      requestComboRol: {
        perPage: 100,
        cuerrentPage: 0,
        filter: '',
      },            
      items: [
        {
          text: 'Sistemas Tributario',
          href: '/',
        },
        {
          text: 'Usuarios',
          href: '/usuarios/',
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
       submitted: false,
       isBusy: false
    }
  },
  validations: {
    form: {        
        contrasena: { required,
                    minLength: minLength(8),
                    maxLength: maxLength(50) },                     
        correo: { required,
                  email,
                  async isUniqueMail(value){
                    if (value === '') return true
                     let promise = axios
                        .get(appConfig.recursosApi.validacionCorreoDuplicado + value)
                        return promise
                                .then((response) => {
                                 
                                   return !response.data.existe
                                  
                                   })
                        .catch(()=>  {
                             
                              return false
               
                            }); 

                    }
                   },        
        nombreUsuario: { required,
                  minLength: minLength(6),
                  async isUnique(value){
                    if (value === '') return true
                     let promise = axios
                        .get(appConfig.recursosApi.validacionUsuarioDuplicado + value)
                        return  promise
                                .then((response) => {
                                 
                                   return !response.data.existe
                                  
                                   })
                        .catch(()=>  {                             
                              return false               
                            });
                       

                    }
                  },
      caja:{
        required
      },
      rol:{
        required
      }
    },    
},
  computed:{
  
  },
  mounted(){
    this.loadCajas();
     this.loadRol();
  },
   methods:{  
     loadCajas(query = '') {
      this.isLoadingComboCajas = true
      this.requestComboCajas.filter = query
      axios
        .get(appConfig.recursosApi.caja, {
          params: this.requestComboCajas,
        })
        .then((response) => {
          this.listadoCajas = response.data.result
          this.isLoadingComboCajas = false
          return this.data
        })
        .catch(() => {
          this.listadoCajas = []
          this.isLoadingComboCajas = false
          // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
          this.$router.push('/500')
        })
    }, 
    loadRol(query = '') {
      this.isLoadingComboRol = true
      this.requestComboRol.filter = query
      axios
        .get(appConfig.recursosApi.usuario + "/rol", {
          params: this.requestComboRol,
        })
        .then((response) => {
          this.listadoRol = response.data.result
          this.isLoadingComboRol = false
          return this.data
        })
        .catch(() => {
          this.listadoRol = []
          this.isLoadingComboRol = false
          // Si ocurre algun error al cargar el listado mandamos un error 500 a la vista.
         // this.$router.push('/500')
        })
    },  
     _validations () {
      return new Promise(resolve => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid () {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },
    
    async handleSubmit(e) {
      this.submitted = true;      
      const valid = await this.isValid();
      this.isBusy = false;
     
      if(valid){
        this.isBusy = true;
        axios
            .post(appConfig.recursosApi.usuario , this.form)
            .then((response) => {
              this.isBusy = false;
               this.$router.push('/usuarios/index/true') ;
            }).catch(()=>  {
              
              this.isBusy = false;
               Vue.swal({
        type: 'error',
        title: 'Oops...',
        text: 'Ocurrio un error al intentar guardar los datos.',
        confirmButtonClass: 'btn btn-confirm mt-2',
        
      })
            });

      }
     
    },
   }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
 <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Nuevo usuario</h4>
          <p
            class="text-muted font-14 m-b-20"
          >Ingresa la información del usuario.</p>

          <form @submit.prevent="handleSubmit">            
            <!-- Datos Usuario -->
             <div class="form-row"> 
                <div class="form-group col-md-12">
                    <label for="name">
                     Nombre
                        <span class="text-danger">*</span>
                    </label>
                     <input
                    id="nombre"
                        v-model="form.nombre"
                        name="nombre"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.nombre.$error }"
                        type="text"
                        placeholder=""
                    />
                 <div
                    v-if="submitted && $v.form.nombre.$error" class="invalid-feedback" >
                     <span v-if="!$v.form.nombre.required"  >Debe indicar un nombre usuario unico.</span>
                    
                    </div>
                    
                </div>
                
            </div>
            <div class="form-row"> 
                <div class="form-group col-md-6">
                    <label for="name">
                     Usuario
                        <span class="text-danger">*</span>
                    </label>
                     <input
                    id="usuario"
                        v-model="form.nombreUsuario"
                        name="usuario"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.nombreUsuario.$error }"
                        type="text"
                        placeholder=""
                    />
                 <div
                    v-if="submitted && $v.form.nombreUsuario.$error" class="invalid-feedback" >
                     <span v-if="!$v.form.nombreUsuario.required"  >Debe indicar un nombre usuario unico.</span>
                    <span v-if="!$v.form.nombreUsuario.minLength"  >El usuario debe ser minimo de  6 caracteres.</span>
                    <span v-if="!$v.form.nombreUsuario.isUnique">El usuario ya se se encuentra registrado.</span>
                    </div>
                    
                </div>
                <div class="form-group col-md-6">
                    <label>
                        Correo
                        <span class="text-danger">*</span>
                    </label>
                    <input
                        v-model="form.correo"
                        type="text"
                        name="correo"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.correo.$error }"
                        placeholder=""/>
                        <div v-if="submitted && $v.form.correo.$error" class="invalid-feedback">
                            <span v-if="!$v.form.correo.required">Ingrese un correo al cual le llegaran las notificaciones al usuario.</span>
                            <span v-if="!$v.form.correo.email">Ingrese un correo valido.</span>
                            <span v-if="!$v.form.correo.isUniqueMail" >El correo ya se se encuentra registrado.</span>
                        </div>
                </div>
                <div class="form-group col-md-4">
                    <label>
                        Contraseña
                        <span class="text-danger"></span>
                    </label>
                    <input
                        v-model="form.contrasena"
                        type="password"
                        name="contrasena"
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.contrasena.$error }"
                        placeholder=""/>

                         <div v-if="submitted && $v.form.contrasena.$error" class="invalid-feedback">                            
                            <span v-if="!$v.form.contrasena.minLength">La contraseña debe ser minimo de 8 caracteres.</span>
                           <span v-if="!$v.form.contrasena.maxLength">La contraseña debe ser maximo de 50 caracteres.</span>
                        </div>

                       
                      
                </div>
            </div>
           <div class="form-row"> 
                <div class="form-group col-md-6">
                    <label for="name">
                     Caja
                        <span class="text-danger">*</span>
                    </label>
                     <multiselect
                  id="caja"
                  v-model="form.caja"
                  label="descripcion"
                  track-by="cajaId"
                  placeholder="Teclea una caja"
                  open-direction="bottom"
                  deselect-label=" X "
                  select-label=" + "
                  selected-label=" Seleccionado"
                  :options="listadoCajas"
                  :multiple="false"
                  :searchable="true"
                  :loading="isLoadingComboCajas"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="100"
                  :limit="3"
                  :max-height="500"
                  :show-no-results="true"
                  :hide-selected="false"
                  :class="{
                    'is-invalid': submitted && $v.form.caja.$error,
                  }"
                  @search-change="loadCajas"
                >
                  <span slot="noResult">No se encontraron resultados.</span>
                  <span slot="noOptions">No se encontraron cajas.</span>
                </multiselect>
                 <div
                    v-if="submitted && $v.form.caja.$error" class="invalid-feedback" >
                     <span v-if="!$v.form.caja.required"  >Debe seleccionar una caja.</span>                    
                    </div>
                    
                </div>
                <div class="form-group col-md-6">
                    <label>
                        Rol
                        <span class="text-danger">*</span>
                    </label>
                    <multiselect
                  id="rol"
                  v-model="form.rol"
                  label="descripcion"
                  track-by="rolId"
                  placeholder="Teclea una rol"
                  open-direction="bottom"
                  deselect-label=" X "
                  select-label=" + "
                  selected-label=" Seleccionado"
                  :options="listadoRol"
                  :multiple="false"
                  :searchable="true"
                  :loading="isLoadingComboRol"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="100"
                  :limit="3"
                  :max-height="500"
                  :show-no-results="true"
                  :hide-selected="false"
                  :class="{
                    'is-invalid': submitted && $v.form.rol.$error,
                  }"
                  @search-change="loadRol"                >
                  <span slot="noResult">No se encontraron resultados.</span>
                  <span slot="noOptions">No se encontraron Roles.</span>
                </multiselect>
                    
                        <div v-if="submitted && $v.form.rol.$error" class="invalid-feedback">
                            <span v-if="!$v.form.rol.required">Debe selecionar un rol.</span>                            
                        </div>
                </div>
            </div>
          
            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">   <b-spinner v-show="isBusy"  small></b-spinner>  Guardar</button>
              <router-link class="btn btn-secondary m-l-5 ml-1" to="/usuarios/index"> Cancelar</router-link>
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
 </div>
  </Layout>
</template>